import { CheckCircleIcon, ExclamationIcon } from '@heroicons/react/outline';

// Sticky save-state pill. Always visible so the patient can trust the form is
// being saved. Values for `state`: 'idle' | 'saving' | 'saved' | 'failed'.
const SaveIndicator = ({ state, onRetry }) => {
  let label = 'All changes saved';
  let icon = (
    <CheckCircleIcon className="w-5 h-5 text-green-600" aria-hidden="true" />
  );
  let bg = 'bg-white border-gray-200 text-mmj-header';
  let role = 'status';
  let onClick = null;

  if (state === 'saving') {
    label = 'Saving…';
    icon = (
      <span
        className="inline-block w-4 h-4 border-2 border-mmj-blue border-t-transparent rounded-full animate-spin"
        aria-hidden="true"
      />
    );
  } else if (state === 'failed') {
    label = 'Save failed — tap to retry';
    icon = (
      <ExclamationIcon className="w-5 h-5 text-red-600" aria-hidden="true" />
    );
    bg = 'bg-red-50 border-red-300 text-red-800';
    role = 'alert';
    onClick = onRetry || null;
  } else if (state === 'idle') {
    return null;
  }

  const className =
    'fixed bottom-4 right-4 md:bottom-6 md:right-6 z-40 flex items-center space-x-2 px-4 py-3 rounded-full shadow-mmj-lg border text-base font-medium ' +
    bg +
    (onClick ? ' cursor-pointer hover:opacity-90' : '');

  return (
    <div
      role={role}
      aria-live="polite"
      className={className}
      onClick={onClick || undefined}
      style={{ minHeight: '44px', minWidth: '120px' }}
    >
      {icon}
      <span>{label}</span>
    </div>
  );
};

export default SaveIndicator;
